<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link>
            &rsaquo;
            <router-link
              :to="{
                name: 'AtencionForm',
                state: { idAtencion: p_idAtencion }
              }"
            >
              Atención {{ p_numero }}
            </router-link>			
            &rsaquo; Referencias - Derivaciones
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Referencias / Derivaciones">
      <AyudaAtencionReferencia />
    </Modal>

    <hr />

    <!-- Bloque: Datos de la Atención -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Datos de la Atención</b>
      <button class="btn btn-link p-0 text-decoration-none" @click="mostrarBloque = !mostrarBloque">
        <span class="material-symbols-outlined align-middle">
          {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
        </span>
        {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
      </button>
    </div>
    <div class="form-card mb-3">
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Paciente</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombrePaciente" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Cédula</label></div>
          <div class="col-2">
            <input type="text" class="form-control" v-model="datoAtencion.documentoPaciente" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Tipo</label></div>
          <div class="col-2">
            <select class="form-select" v-model="datoAtencion.tipo" disabled>
              <option value="I">Inicial</option>
              <option value="S">Subsecuente</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Médico</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreMedico" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Especial.</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreEspecialidad" disabled />
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-1"><label class="col-form-label">Motivo</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.motivo"
              style="text-transform:uppercase" disabled></textarea>
          </div>
          <div class="col-1"><label class="col-form-label">Obs.</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.observacion"
              style="text-transform:uppercase" disabled></textarea>
          </div>
        </div>
      </div>
      <!-- Sección colapsable -->
      <div v-if="mostrarBloque" class="mb-3">
        <hr class="my-2" />
        <div class="row">
          <div class="col-2">
            <label class="form-label">Id. Atención</label>
            <input type="text" class="form-control" :value="datoAtencion.idAtencion" disabled />
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Reg.</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaReg)" disabled />
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Act.</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaAct)" disabled />
          </div>
        </div>
      </div>
    </div>

    <hr />

    <!-- DataTable de Referencias -->
    <DataTable
      :data="referencias"
      :columns="columnasReferencia"
      idField="idReferencia"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="estadoPermitido"
      mensajeVacio="No hay referencias registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idReferencia)"
      @view="row => abrirEditarDet(row.idReferencia)"
      @delete="row => deleteReferencia(row.idReferencia)"
    >
      <template #acciones-fila="{ row }">
        <button class="btn btn-sm btn-outline-secondary"
          @click="formulario053_PDF(row.idReferencia)" title="Formulario informe">
          <span class="material-icons" style="font-size:14px">picture_as_pdf</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal Referencia -->
    <Teleport to="body">
      <div class="modal fade" id="ventanaModal" tabindex="-1"
        aria-labelledby="ventanaModalLabel" aria-hidden="true" ref="modalRef">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="ventanaModalLabel">
                <span class="material-symbols-outlined align-middle me-2" style="font-size:20px">
                  {{ btnCrear_det ? 'add_circle' : 'edit' }}
                </span>
                {{ titulo }}
              </h5>
              <button type="button" class="btn-close btn-close-white"
                @click="cerrarModal" aria-label="Cerrar"></button>
            </div>

            <div class="modal-body">
              <div v-if="btnEditar_det" class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Id. Referencia</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoReferencia.idReferencia" disabled />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Motivo Ref./Der.</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idMotivoRef" :disabled="!estadoPermitido">
                      <option v-for="m in motivoRefs" :value="m.idMotivoRef" :key="m.idMotivoRef">{{ m.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Destino</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idEmpresaDestino"
                      :disabled="!estadoPermitido" @change="fetchMedicos">
                      <option v-for="e in empresaDestinos" :value="e.idEmpresaDestino" :key="e.idEmpresaDestino">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Especialidad</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idEspecialidad" :disabled="!estadoPermitido">
                      <option v-for="e in especialidades" :value="e.idEspecialidad" :key="e.idEspecialidad">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Médico</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idMedico" :disabled="!estadoPermitido">
                      <option v-for="m in medicos" :value="m.idMedico" :key="m.idMedico">
                        {{ m.nombreCompleto }} — {{ m.especialidadNombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Fecha Ref./Der.</label></div>
                  <div class="col-4">
                    <input type="date" class="form-control" v-model="datoReferencia.fechaRef" :disabled="!estadoPermitido" />
                  </div>
                  <div class="col-2"><label class="col-form-label">Hora</label></div>
                  <div class="col-4">
                    <input type="time" class="form-control" v-model="datoReferencia.hora" :disabled="!estadoPermitido" />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Tipo</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.tipo" :disabled="!estadoPermitido">
                      <option value="R">R: Referencia</option>
                      <option value="D">D: Derivación</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Campos de dictado -->
              <div v-for="campo in camposDictado" :key="campo.field" class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">{{ campo.label }}</label></div>
                  <div class="col-10">
                    <div class="textarea-container-mic">
                      <textarea class="form-control" v-model="datoReferencia[campo.field]"
                        style="text-transform:uppercase" :disabled="!estadoPermitido" rows="2"></textarea>
                      <div class="buttons-container-mic">
                        <button v-if="!campo.isDictating" type="button" class="btn btn-light"
                          title="Iniciar dictado" :disabled="!estadoPermitido"
                          @click="startDictation(campo)">
                          <span class="material-symbols-outlined" style="font-size:32px;color:orangered">mic_off</span>
                        </button>
                        <button v-else type="button" class="btn btn-light"
                          title="Detener dictado" @click="stopDictation(campo)">
                          <span class="material-symbols-outlined" style="font-size:32px;color:green">mic</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="col-form-label">Justificada</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.justificada" :disabled="!estadoPermitido">
                      <option value="S">Sí</option>
                      <option value="N">No</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm" @click="cerrarModal">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">close</span>
                Cancelar
              </button>
              <button v-if="btnCrear_det" class="btn btn-success btn-sm"
                @click.prevent="guardarReferencia">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">save</span>
                Guardar
              </button>
              <button v-if="btnEditar_det && estadoPermitido" class="btn btn-primary btn-sm"
                @click.prevent="guardarEditReferencia">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">update</span>
                Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import SpeechDictation from '@/modules/microfono.js'
import AyudaAtencionReferencia from '@/views/ayuda/AyudaAtencionReferencia.vue'
import api from '@/services/api'
import config from '@/config.js'
import { Modal } from 'bootstrap'
import Swal from 'sweetalert2'

export default {
  name: 'AtencionReferencia',
  components: { Layout, Footer, DataTable, AyudaAtencionReferencia },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
  },

  data() {
    return {
      datoAtencion: {},
      mostrarBloque: false,
      showModalHelp: false,
      referencias: [],
      datoReferencia: {},
      titulo: '',
      btnCrear_det: false,
      btnEditar_det: false,
      modalInstance: null,
      motivoRefs: [],
      empresaDestinos: [],
      especialidades: [],
      medicos: [],
      dictation: new SpeechDictation(),
      columnasReferencia: [
        { field: 'fechaRef', label: 'Fecha Ref.', format: (val) => dateFormat.getFormattedDate(val) },
        { field: 'hora',     label: 'Hora' },
        { field: 'tipo',     label: 'Tipo' },
        { field: 'motivo',   label: 'Motivo' },
      ],
      camposDictado: [
        { field: 'motivo',      label: 'Motivo',      isDictating: false },
        { field: 'resumen',     label: 'Resumen',     isDictating: false },
        { field: 'hallazgos',   label: 'Hallazgos',   isDictating: false },
        { field: 'tratamiento', label: 'Tratamiento', isDictating: false },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  mounted() {
    this.cargarAtencion()
    this.getDataTodos()
    this.fetchMotivoRefs()
    this.fetchEmpresaDestinos()
    this.fetchEspecialidades()
    this.$nextTick(() => {
      if (this.$refs.modalRef) {
        this.modalInstance = new Modal(this.$refs.modalRef)
      }
    })
  },

  beforeUnmount() {
    this.camposDictado.forEach(c => { if (c.isDictating) this.stopDictation(c) })
    if (this.modalInstance) this.modalInstance.dispose()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    // ── Atención ─────────────────────────────────────────────────────────
    async cargarAtencion() {
      try {
        const resp = await api.get(`/vwatencions/${this.p_idAtencion}`)
        this.datoAtencion = resp.data
      } catch (err) {
        console.error('Error cargando atención:', err)
      }
    },

    // ── Referencias ──────────────────────────────────────────────────────
    async getDataTodos() {
      try {
        const resp = await api.get(`/vwreferencias/idatencion/${this.p_idAtencion}`)
        this.referencias = resp.data.reverse()
      } catch (err) {
        console.error('Error cargando referencias:', err)
      }
    },

    abrirModalCrear() {
      this.datoReferencia = {}
      this.titulo         = 'Nueva Referencia / Derivación'
      this.btnCrear_det   = true
      this.btnEditar_det  = false
      this.modalInstance?.show()
    },

    async abrirModalEditar(idReferencia) {
      this.titulo        = 'Editar Referencia / Derivación'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      try {
        const resp = await api.get(`/vwreferencias/${idReferencia}`)
        this.datoReferencia = resp.data
      } catch (err) {
        console.error('Error cargando referencia:', err)
      }
      this.modalInstance?.show()
    },

    cerrarModal() {
      this.modalInstance?.hide()
    },

abrirEditarDet(idReferencia) {

  this.$router.push({
    name: 'ReferenciaForm',
    state: {
      idAtencion:     this.p_idAtencion,
      numeroAtencion: this.p_numero,
      idReferencia:   idReferencia,
      estadoAtencion: this.p_estadoAtencion,
      pagina:         'A',
    }
  });
},

    async guardarReferencia() {
      try {
        this.datoReferencia.idEmpresaOrigen = window.sessionStorage.getItem('idEmpresa')
        this.datoReferencia.idAtencion      = this.datoAtencion.idAtencion
        this.datoReferencia.idPersona       = this.datoAtencion.idPersona
        await api.post('/referencias', this.datoReferencia)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Guardado', text: 'Referencia creada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar. Intente de nuevo.' })
      }
    },

    async guardarEditReferencia() {
      try {
        await api.post('/referencias', this.datoReferencia)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Actualizado', text: 'Referencia actualizada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar. Intente de nuevo.' })
      }
    },

    async deleteReferencia(idReferencia) {
      const { isConfirmed } = await Swal.fire({
        title: '¿Eliminar referencia?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })
      if (!isConfirmed) return
      try {
        await api.delete(`/referencias/${idReferencia}`)
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar.' })
      }
    },

    formulario053_PDF(idReferencia) {
      window.open(`${config.apiReportesUrl}/7/${idReferencia}`, '_blank')
    },

    // ── Catálogos ─────────────────────────────────────────────────────────
    fetchMotivoRefs()      { api.get('/vwmotivorefs').then(r => { this.motivoRefs = r.data }) },
    fetchEmpresaDestinos() { api.get('/vwempresas').then(r => { this.empresaDestinos = r.data }) },
    fetchEspecialidades()  { api.get('/vwespecialidads').then(r => { this.especialidades = r.data }) },
    fetchMedicos() {
      if (!this.datoReferencia.idEmpresaDestino) return
      api.get(`/vwmedicos/idempresa/${this.datoReferencia.idEmpresaDestino}`)
        .then(r => { this.medicos = r.data })
    },

    // ── Dictado ───────────────────────────────────────────────────────────
    startDictation(campo) {
      campo.isDictating = true
      this.dictation.startDictation((transcript) => {
        this.datoReferencia[campo.field] = transcript
      }, this.datoReferencia[campo.field])
    },
    stopDictation(campo) {
      campo.isDictating = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>

<style scoped>
.btn-help {
  background: none; border: none; padding: 0; cursor: pointer; color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px; transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined { color: #0a58ca; }
</style>